<div class="vc-appt-wizard">
  <header class="vc-appt-wizard__header">
    <span class="vc-appt-wizard__progress-label"
      >Paso {{ currentStepIndex + 1 }} de {{ visibleSteps.length }}</span
    >
  </header>

  <div class="vc-appt-wizard__progress">
    <div
      class="vc-appt-wizard__progress-bar"
      [style.width.%]="progressPercent"
    ></div>
  </div>

  <ol class="vc-appt-wizard__steps">
    <li
      *ngFor="let step of visibleSteps; let index = index"
      [class.is-active]="step === currentStep"
      [class.is-complete]="index < currentStepIndex"
    >
      <span>{{ index + 1 }}</span>
      <small>
        {{
          step === 'patient'
              ? 'Paciente'
              : step === 'treatments'
                ? 'Tratamientos'
                : step === 'professionals'
                  ? 'Profesionales (opcional)'
                  : step === 'payment'
                    ? 'Pago'
                    : step === 'time'
                      ? 'Hora'
                      : 'Resumen'
        }}
      </small>
    </li>
  </ol>

  <div class="vc-appt-wizard__content">
  <section class="vc-appt-step" *ngIf="currentStep === 'patient'">
    <h3>Paciente</h3>
    <p class="vc-appt-step__intro">
      Este paso es opcional. Si no estás seguro de si existe, búscalo primero.
      Si lo seleccionas, se entiende como paciente existente.
    </p>

    <div class="vc-appt-toggle-group">
      <button
        pButton
        type="button"
        [class.p-button-outlined]="patientSelectionMode !== 'existing'"
        (click)="changePatientMode('existing')"
      >
        Paciente existente
      </button>
      <button
        pButton
        type="button"
        [class.p-button-outlined]="patientSelectionMode !== 'new'"
        (click)="changePatientMode('new')"
      >
        Paciente nuevo
      </button>
      <button
        pButton
        type="button"
        class="p-button-outlined"
        (click)="continueWithoutPatient()"
      >
        Continuar sin paciente
      </button>
    </div>

    <div class="vc-appt-panel" *ngIf="patientSelectionMode === 'existing'">
      <div *ngIf="!patient?.id" class="vc-appt-field">
        <label>Buscar paciente</label>
        <app-patient-searcher
          #patientSearcher
          [onSelect]="managePatient.bind(this)"
        ></app-patient-searcher>
      </div>

      <div class="vc-appt-patient-summary" *ngIf="patient?.id">
        <div class="vc-appt-patient-summary__identity">
          <span class="vc-appt-avatar">{{ getPatientInitials() }}</span>
          <div>
            <strong>{{ patient.name }} {{ patient.surname }}</strong>
            <small *ngIf="patient.email">{{ patient.email }}</small>
            <small *ngIf="patient.phone">{{ patient.phone }}</small>
          </div>
        </div>

        <div class="vc-appt-patient-summary__actions">
          <button
            pButton
            type="button"
            class="p-button-outlined"
            (click)="toggleExistingPatientEdition()"
          >
            {{ patientEditMode ? 'Ocultar edición' : 'Completar información' }}
          </button>
          <button
            pButton
            type="button"
            class="p-button-outlined p-button-danger"
            (click)="clearPatientSelection()"
            *ngIf="!patientOnInit"
          >
            Cambiar paciente
          </button>
        </div>
      </div>

      <div class="vc-appt-inline-form" *ngIf="patient?.id && patientEditMode">
        <div class="vc-appt-grid vc-appt-grid--patient">
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Nombre *</label>
            <input
              name="existing_patient_name"
              [ngModel]="patientDraft.name"
              (ngModelChange)="patientDraft.name = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Apellidos</label>
            <input
              name="existing_patient_surname"
              [ngModel]="patientDraft.surname"
              (ngModelChange)="patientDraft.surname = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Email</label>
            <input
              name="existing_patient_email"
              [ngModel]="patientDraft.email"
              (ngModelChange)="patientDraft.email = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Género</label>
            <p-select
              [options]="genderOptions"
              [optionLabel]="'name'"
              [optionValue]="'code'"
              [showClear]="true"
              [ngModel]="patientDraft.gender"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="patientDraft.gender = $event; onPatientDraftInput()"
              [appendTo]="'body'"
              size="small"
              fluid
            ></p-select>
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Teléfono</label>
            <input
              name="existing_patient_phone"
              [ngModel]="patientDraft.phone"
              (ngModelChange)="patientDraft.phone = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>DNI / NIF</label>
            <input
              name="existing_patient_fiscal_id"
              [ngModel]="patientDraft.fiscal_id"
              (ngModelChange)="patientDraft.fiscal_id = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Fecha de nacimiento</label>
            <p-datepicker
              name="existing_patient_birthday"
              [ngModel]="patientDraft.birthday"
              (ngModelChange)="patientDraft.birthday = $event; onPatientDraftInput()"
              [showTime]="false"
              [firstDayOfWeek]="1"
              [appendTo]="'body'"
              dateFormat="dd/mm/yy"
              size="small"
              fluid
            ></p-datepicker>
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Código postal</label>
            <input
              name="existing_patient_postcode"
              [ngModel]="patientDraft.postcode"
              (ngModelChange)="patientDraft.postcode = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-lg">
            <label>Dirección</label>
            <input
              name="existing_patient_address"
              [ngModel]="patientDraft.address"
              (ngModelChange)="patientDraft.address = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-xl">
            <label>Observaciones</label>
            <textarea
              pTextarea
              name="existing_patient_remarks"
              [ngModel]="patientDraft.remarks"
              (ngModelChange)="patientDraft.remarks = $event; onPatientDraftInput()"
              [rows]="2"
              autoResize="autoResize"
              fluid
            ></textarea>
          </div>
          <div class="vc-appt-field vc-appt-field--compact-lg">
            <label>Dónde nos has conocido</label>
            <app-selector-marketing-channels
              [selected]="patientDraft.marketingChannel"
              [onChange]="onPatientMarketingChannelChange.bind(this)"
            ></app-selector-marketing-channels>
          </div>
        </div>
      </div>
    </div>

    <div class="vc-appt-panel" *ngIf="patientSelectionMode === 'new'">
      <div class="vc-appt-inline-form">
        <div class="vc-appt-grid vc-appt-grid--patient">
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Nombre *</label>
            <input
              name="new_patient_name"
              [ngModel]="patientDraft.name"
              (ngModelChange)="patientDraft.name = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Apellidos</label>
            <input
              name="new_patient_surname"
              [ngModel]="patientDraft.surname"
              (ngModelChange)="patientDraft.surname = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Email</label>
            <input
              name="new_patient_email"
              [ngModel]="patientDraft.email"
              (ngModelChange)="patientDraft.email = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Género</label>
            <p-select
              [options]="genderOptions"
              [optionLabel]="'name'"
              [optionValue]="'code'"
              [showClear]="true"
              [ngModel]="patientDraft.gender"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="patientDraft.gender = $event; onPatientDraftInput()"
              [appendTo]="'body'"
              size="small"
              fluid
            ></p-select>
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Teléfono</label>
            <input
              name="new_patient_phone"
              [ngModel]="patientDraft.phone"
              (ngModelChange)="patientDraft.phone = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>DNI / NIF</label>
            <input
              name="new_patient_fiscal_id"
              [ngModel]="patientDraft.fiscal_id"
              (ngModelChange)="patientDraft.fiscal_id = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Fecha de nacimiento</label>
            <p-datepicker
              name="new_patient_birthday"
              [ngModel]="patientDraft.birthday"
              (ngModelChange)="patientDraft.birthday = $event; onPatientDraftInput()"
              [showTime]="false"
              [firstDayOfWeek]="1"
              [appendTo]="'body'"
              dateFormat="dd/mm/yy"
              size="small"
              fluid
            ></p-datepicker>
          </div>
          <div class="vc-appt-field vc-appt-field--compact-sm">
            <label>Código postal</label>
            <input
              name="new_patient_postcode"
              [ngModel]="patientDraft.postcode"
              (ngModelChange)="patientDraft.postcode = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-lg">
            <label>Dirección</label>
            <input
              name="new_patient_address"
              [ngModel]="patientDraft.address"
              (ngModelChange)="patientDraft.address = $event; onPatientDraftInput()"
            />
          </div>
          <div class="vc-appt-field vc-appt-field--compact-xl">
            <label>Observaciones</label>
            <textarea
              pTextarea
              name="new_patient_remarks"
              [ngModel]="patientDraft.remarks"
              (ngModelChange)="patientDraft.remarks = $event; onPatientDraftInput()"
              [rows]="2"
              autoResize="autoResize"
              fluid
            ></textarea>
          </div>
          <div class="vc-appt-field vc-appt-field--compact-lg">
            <label>Dónde nos has conocido</label>
            <app-selector-marketing-channels
              [selected]="patientDraft.marketingChannel"
              [onChange]="onPatientMarketingChannelChange.bind(this)"
            ></app-selector-marketing-channels>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="vc-appt-step" *ngIf="currentStep === 'treatments'">
    <h3>Tratamientos</h3>
    <p class="vc-appt-step__intro">
      Selecciona tratamientos asignados al paciente o añade extras. Aquí solo
      seleccionas tratamientos y su estado de pago.
    </p>

    <div class="vc-appt-toggle-group">
      <button
        pButton
        type="button"
        class="p-button-outlined"
        *ngIf="addTreatmentsNow"
        (click)="continueWithoutTreatments()"
      >
        Continuar sin tratamientos
      </button>
      <button
        pButton
        type="button"
        *ngIf="!addTreatmentsNow"
        (click)="onAddTreatmentsNowChange(true)"
      >
        Añadir tratamientos
      </button>
    </div>

    <div class="vc-appt-panel" *ngIf="addTreatmentsNow && patient?.id">
      <app-treatment-manager
        [patient]="patient"
        [site]="site"
        [calendar]="calendar"
        [customersId]="customers_id"
        [showProfessionalPanel]="false"
        [allowPaymentActions]="false"
        [simpleLayout]="true"
        (selectedTreatmentsChange)="onTreatmentsSelected($event)"
      ></app-treatment-manager>
    </div>

    <p class="vc-appt-muted" *ngIf="!addTreatmentsNow">
      Se usará una duración base de 30 minutos y podrás ajustarla en el paso de
      hora.
    </p>
  </section>

  <section class="vc-appt-step" *ngIf="currentStep === 'professionals'">
    <h3>Profesionales (opcional)</h3>
    <p class="vc-appt-step__intro">
      Paso opcional. Puedes asignar un profesional por tratamiento o dejarlo sin asignar.
    </p>

    <div class="vc-appt-panel">
      <div class="vc-appt-grid vc-appt-grid--professionals-header">
        <div class="vc-appt-field vc-appt-field--compact-sm">
          <label>Asignar a todos</label>
          <p-select
            [options]="professionals"
            [optionLabel]="'fullName'"
            [optionValue]="'id'"
            [showClear]="true"
            [ngModel]="globalProfessionalId"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="globalProfessionalId = $event"
            [appendTo]="'body'"
            size="small"
            fluid
          ></p-select>
        </div>
        <div class="vc-appt-field vc-appt-field--action vc-appt-field--actions-inline">
          <button pButton type="button" class="p-button-outlined" (click)="applyGlobalProfessionalToAll()">
            Aplicar a todos
          </button>
          <button pButton type="button" class="p-button-outlined" (click)="skipProfessionalsAndContinue()">
            Omitir paso
          </button>
        </div>
      </div>

      <div class="vc-appt-table-wrap">
        <table class="vc-appt-table">
          <thead>
            <tr>
              <th>Tratamiento</th>
              <th>Profesional</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let treatment of selectedTreatments">
              <td>
                <strong>{{ treatment?.treatment?.name || ('Tratamiento #' + treatment.id) }}</strong>
                <small>{{ treatment?.price | number: '1.2-2' }} {{ site?.currency || '' }}</small>
              </td>
              <td>
                <p-select
                  [options]="getProfessionalOptionsForTreatment(treatment)"
                  [optionLabel]="'fullName'"
                  [optionValue]="'id'"
                  [showClear]="true"
                  [ngModel]="professionalAssignments[treatment.id || 0]"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onProfessionalAssigned(treatment.id || 0, $event)"
                  [appendTo]="'body'"
                  size="small"
                  fluid
                ></p-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <section class="vc-appt-step" *ngIf="currentStep === 'payment'">
    <h3>Pago (opcional)</h3>
    <p class="vc-appt-step__intro">
      Deja preparados los cobros de los tratamientos pendientes si quieres hacerlo ahora.
    </p>

    <div class="vc-appt-panel">
      <div class="vc-appt-grid vc-appt-grid--payments-template">
        <div class="vc-appt-field">
          <label>Método de pago (todos)</label>
          <p-select
            [options]="paymentTypes"
            [optionLabel]="'name'"
            [optionValue]="'id'"
            [ngModel]="paymentTemplate.paymentTypeId"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="updatePaymentTemplateType($event)"
            [appendTo]="'body'"
            size="small"
            fluid
          ></p-select>
        </div>

        <div class="vc-appt-field">
          <label>Fecha y hora (todos)</label>
          <p-datepicker
            [ngModel]="paymentTemplate.paymentDateTime"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="updatePaymentTemplateDate($event)"
            [showTime]="true"
            [hourFormat]="'24'"
            [appendTo]="'body'"
            dateFormat="dd/mm/yy"
            size="small"
            fluid
          ></p-datepicker>
        </div>

        <div class="vc-appt-field vc-appt-field--action vc-appt-field--actions-inline">
          <button pButton type="button" class="p-button-outlined" (click)="applyTemplateToAllPendingTreatments()">
            Aplicar a todos
          </button>
          <button pButton type="button" class="p-button-outlined" (click)="skipPaymentsAndContinue()">
            Omitir paso
          </button>
        </div>
      </div>

      <div class="vc-appt-table-wrap">
        <table class="vc-appt-table">
          <thead>
            <tr>
              <th>Tratamiento</th>
              <th>Estado</th>
              <th>Método de pago</th>
              <th>Fecha y hora</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let draft of treatmentPayments">
              <td>
                <strong>{{ draft.treatmentName }}</strong>
                <small>{{ draft.treatmentPrice | number: '1.2-2' }} {{ site?.currency || '' }}</small>
              </td>
              <td>
                <span class="vc-status-pill" [class.vc-status-pill--paid]="draft.isAlreadyPaid" [class.vc-status-pill--pending]="!draft.isAlreadyPaid">
                  {{ draft.isAlreadyPaid ? 'PAGADO' : 'PENDIENTE DE PAGO' }}
                </span>
                <label class="vc-pay-checkbox" *ngIf="!draft.isAlreadyPaid">
                  <input
                    type="checkbox"
                    name="pay_treatment_{{ draft.treatmentId }}"
                    [ngModel]="draft.shouldCreatePayment"
                    (ngModelChange)="draft.shouldCreatePayment = $event"
                  />
                  Cobrar en esta cita
                </label>
              </td>
              <td>
                <p-select
                  [options]="paymentTypes"
                  [optionLabel]="'name'"
                  [optionValue]="'id'"
                  [ngModel]="draft.paymentTypeId"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="updateDraftType(draft, $event)"
                  [appendTo]="'body'"
                  size="small"
                  fluid
                  [disabled]="draft.isAlreadyPaid || !draft.shouldCreatePayment"
                ></p-select>
              </td>
              <td>
                <p-datepicker
                  [ngModel]="draft.paymentDateTime"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="updateDraftDate(draft, $event)"
                  [showTime]="true"
                  [hourFormat]="'24'"
                  [appendTo]="'body'"
                  dateFormat="dd/mm/yy"
                  size="small"
                  fluid
                  [disabled]="draft.isAlreadyPaid || !draft.shouldCreatePayment"
                ></p-datepicker>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <section class="vc-appt-step" *ngIf="currentStep === 'time'">
    <h3>Fecha y hora</h3>

    <p class="vc-appt-muted" *ngIf="!calendar">
      Cargando calendario disponible...
    </p>

    <div class="vc-appt-field vc-appt-field--compact-xl" *ngIf="calendarOptions.length > 1">
      <label>Calendario</label>
      <p-select
        [options]="calendarOptions"
        [optionLabel]="'name'"
        [optionValue]="'id'"
        [showClear]="false"
        [ngModel]="calendar?.id"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onWizardCalendarChange($event)"
        [appendTo]="'body'"
        size="small"
        fluid
      ></p-select>
    </div>

    <div class="vc-appt-day-nav" *ngIf="calendar">
      <button pButton type="button" class="p-button-text" (click)="shiftSelectedDate(-1)">
        <i class="fas fa-chevron-left"></i>
        Día anterior
      </button>
      <p-datepicker
        name="time_step_day_selector"
        [ngModel]="selectedDateOnly"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onDateSelected($event)"
        [showTime]="false"
        [showIcon]="true"
        [readonlyInput]="true"
        [firstDayOfWeek]="1"
        [appendTo]="'body'"
        dateFormat="DD, dd/mm/yy"
        styleClass="vc-appt-day-nav__picker"
      ></p-datepicker>
      <button pButton type="button" class="p-button-text" (click)="shiftSelectedDate(1)">
        Día siguiente
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <div class="vc-appt-grid vc-appt-grid--time" *ngIf="calendar">
      <div class="vc-appt-day-calendar-wrap">
        <div class="vc-appt-day-calendar-scroll" #dayCalendarScrollContainer>
          <ng-template
            #appointmentDayHourSegmentTemplate
            let-segment="segment"
            let-segmentHeight="segmentHeight"
            let-isTimeLabel="isTimeLabel"
            let-locale="locale"
          >
            <div
              class="cal-hour-segment vc-appt-day-segment"
              [style.height.px]="segmentHeight"
              [class.cal-hour-start]="segment.isStart"
              [class.cal-after-hour-start]="!segment.isStart"
              [ngClass]="segment.cssClass"
              (pointerdown)="onDayHourSegmentPointerDown($event, segment.date, segmentHeight)"
              (click)="onDayHourSegmentClickFallback($event, segment.date)"
            >
              <div class="cal-time" *ngIf="isTimeLabel">
                {{ segment.displayDate | calendarDate: "dayViewHour":locale }}
              </div>
            </div>
          </ng-template>

          <div class="vc-appt-day-calendar-content">
            <!-- Rendering calendar events mounts legacy global touch listeners on iPadOS. -->
            <mwl-calendar-day-view
              [viewDate]="dayViewDate"
              [events]="[]"
              [dayStartHour]="dayViewStartHour"
              [dayStartMinute]="dayViewStartMinute"
              [dayEndHour]="dayViewEndHour"
              [dayEndMinute]="dayViewEndMinute"
              [hourSegments]="dayViewHourSegments"
              [hourSegmentHeight]="dayViewHourSegmentHeight"
              [hourSegmentTemplate]="appointmentDayHourSegmentTemplate"
              (beforeViewRender)="onDayViewBeforeRender($event)"
            ></mwl-calendar-day-view>
            <div class="vc-appt-day-events" role="list" aria-label="Citas del día">
              <div
                *ngFor="let item of dayTimelineItems; trackBy: trackDayTimelineItem"
                class="vc-appt-day-event"
                role="listitem"
                [class.vc-appt-day-event--selected]="item.selected"
                [style.top.px]="item.top"
                [style.height.px]="item.height"
                [attr.aria-label]="item.title + ', ' + item.timeLabel"
              >
                <strong>{{ item.title }}</strong>
                <span>{{ item.timeLabel }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vc-appt-slots-panel">
        <app-time-slot-selector
          [selectedDate]="selectedDateOnly"
          [treatmentCount]="selectedTreatments?.length || 0"
          [minutesPerTreatment]="minutesPerTreatment"
          [baseDurationMinutes]="calculatedDurationMinutes"
          [calendar]="calendar"
          [existingAppointments]="dayAppointments"
          [isLoading]="isLoadingAppointments"
          [selectedSlot]="selectedTimeSlot"
          (slotSelected)="onTimeSlotSelected($event)"
          (durationChanged)="onDurationChanged($event)"
          (timeSlotResultChange)="onTimeSlotsComputed($event)"
        ></app-time-slot-selector>
      </div>
    </div>
  </section>

  <section class="vc-appt-step" *ngIf="currentStep === 'review'">
    <h3>Resumen y confirmación</h3>

    <div class="vc-appt-review-grid">
      <article>
        <h4>Agenda</h4>
        <p><strong>Calendario:</strong> {{ calendar?.name || '-' }}</p>
        <p><strong>Día:</strong> {{ reviewDateLabel }}</p>
        <p><strong>Hora:</strong> {{ reviewTimeLabel }}</p>
        <p><strong>Duración:</strong> {{ reviewDurationLabel }}</p>
      </article>

      <article>
        <h4>Paciente</h4>
        <p><strong>Nombre:</strong> {{ patient?.id ? ((patient?.name || '') + ' ' + (patient?.surname || '')) : 'Sin paciente asignado' }}</p>
        <p><strong>Email:</strong> {{ patient?.email || '-' }}</p>
        <p><strong>Teléfono:</strong> {{ patient?.phone || '-' }}</p>
      </article>

      <article>
        <h4>Tratamientos</h4>
        <p *ngIf="!selectedTreatments.length">Sin tratamientos asignados</p>
        <ul *ngIf="selectedTreatments.length">
          <li *ngFor="let treatment of selectedTreatments">
            {{ treatment?.treatment?.name || ('Tratamiento #' + treatment.id) }}
          </li>
        </ul>
      </article>

      <article>
        <h4>Cobro</h4>
        <p>{{ reviewPaymentLabel }}</p>
      </article>
    </div>

    <div class="vc-appt-field vc-appt-field--compact-xl">
      <label>Título de cita (opcional)</label>
      <input
        name="appointment_title"
        [(ngModel)]="appointmentTitle"
        maxlength="120"
      />
    </div>

    <div class="vc-appt-field vc-appt-field--compact-xl">
      <label>Notas internas (opcional)</label>
      <textarea
        pTextarea
        name="appointment_notes"
        [(ngModel)]="appointmentNotes"
        [rows]="4"
        maxlength="200"
        autoResize="autoResize"
        fluid
      ></textarea>
    </div>

    <div class="vc-appt-field vc-appt-field--compact-xl" *ngIf="canOfferEmailReminder">
      <label class="vc-appt-checkbox">
        <input
          type="checkbox"
          name="send_email_reminder"
          [ngModel]="sendEmailReminder"
          (ngModelChange)="sendEmailReminder = $event"
        />
        <span>Mandar correo electrónico</span>
      </label>
      <small class="vc-appt-muted">
        Se enviará un recordatorio de la cita por correo electrónico.
      </small>
    </div>
  </section>

  <section class="vc-form-conflicts" *ngIf="conflicts.length">
    <div class="vc-form-conflicts__header">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ 'MESSAGES.APPOINTMENTS.CONFLICT.SUMMARY' | translate }}</span>
    </div>
    <div class="vc-form-conflicts__message">
      {{
        'MESSAGES.APPOINTMENTS.CONFLICT.DETAIL'
          | translate: { button: ('APPOINTMENT.ADD.ACTION' | translate) }
      }}
    </div>
    <div class="vc-form-conflicts__list">
      <div class="vc-form-conflicts__item" *ngFor="let conflict of conflicts">
        <i class="fas fa-calendar-times"></i>
        <span>{{ conflict.name }} - {{ conflict.start | date: 'HH:mm' }}</span>
      </div>
    </div>
    <div class="vc-form-conflicts__actions">
      <button pButton type="button" class="p-button-outlined" (click)="conflicts = []">
        <i class="fas fa-arrow-left"></i>
        <span>{{ 'COMMON.CANCEL' | translate }}</span>
      </button>
      <button pButton type="button" class="vc-btn-create" (click)="registerEvent(false)">
        <i class="fas fa-calendar-plus"></i>
        <span>{{ 'APPOINTMENT.ADD.ACTION' | translate }}</span>
      </button>
    </div>
  </section>
  </div>

  <footer class="vc-appt-wizard__footer" *ngIf="!conflicts.length">
    <button
      pButton
      type="button"
      class="p-button-outlined"
      (click)="goToPreviousStep()"
      [disabled]="!canGoBack || isSavingPatient"
    >
      Atrás
    </button>

    <button
      pButton
      type="button"
      (click)="goToNextStep()"
      *ngIf="currentStep !== 'review'"
      [disabled]="isSavingPatient || !canGoNext"
    >
      {{ isSavingPatient ? 'Guardando...' : 'Siguiente' }}
    </button>

    <button
      pButton
      type="button"
      class="vc-btn-create"
      (click)="registerEvent(true)"
      [disabled]="!canSave || isSavingPatient"
      *ngIf="currentStep === 'review'"
    >
      <i class="fas fa-calendar-plus"></i>
      <span>{{ 'APPOINTMENT.ADD.ACTION' | translate }}</span>
    </button>
  </footer>
</div>
